module.exports = __webpack_public_path__ + "static/media/cma_color.2d46e9ab.jpg";